export const nonWrappableProducts = {
  se: [
    "0402", "0411", "0850", "GIFOP", "GIFTC", "GCP1000", "0210", "0990", "0980",
    "0981", "0380", "030", "0311", "0390", "0281", "028", "0100", "4551", "0800",
    "0803", "0808", "430", "430", "0470", "4120", "0420",
    "0855", "0430", "900", "0463", "046", "0467", "052", "0690", "0700", "072",
    "0730", "0740", "0750", "0770", "0790", "0710", "0780", "07300", "7400", "9030",
    "0510", "0551", "0580", "0611", "9002", "610", "6100", "605", "606", "750"
  ],
  us: ["0402", "0411", "0850", "GIFOP", "GIFTC", "GCP1000", "0510",
    "0580", "0611", "9002", "610", "0690", "0770",
    "0551", "430", "0470", "4120", "0420", "0430", "900"
  ],
  ca: ["0402", "0411", "0850", "GIFOP", "GIFTC", "GCP1000", "0510",
    "0580", "0611", "9002", "610", "0690", "0770",
    "0551", "430", "0470", "4120", "0420", "0430", "900"
  ],
  eu: [
    "0402", "0411", "0850", "GIFOP", "GIFTC", "GCP1000", "0210", "0990", "0980",
    "0981", "0380", "030", "0311", "0390", "0281", "028", "0100", "4551", "0800",
    "0803", "0808", "430", "430", "0470", "4120", "0420",
    "0855", "0430", "900", "0463", "046", "0467", "052", "0690", "0700", "072",
    "0730", "0740", "0750", "0770", "0790", "0710", "0780", "07300", "7400", "9030",
    "0510", "0551", "0580", "0611", "9002", "610", "6100", "605", "606", "750"
  ],
  fr: [
    "0402", "0411", "0850", "GIFOP", "GIFTC", "GCP1000", "0210", "0990", "0980",
    "0981", "0380", "030", "0311", "0390", "0281", "028", "0100", "4551", "0800",
    "0803", "0808", "430", "430", "0470", "4120", "0420",
    "0855", "0430", "900", "0463", "046", "0467", "052", "0690", "0700", "072",
    "0730", "0740", "0750", "0770", "0790", "0710", "0780", "07300", "7400", "9030",
    "0510", "0551", "0580", "0611", "9002", "610", "6100", "605", "606", "750"
  ],
  de: [
    "0402", "0411", "0850", "GIFOP", "GIFTC", "GCP1000", "0210", "0990", "0980",
    "0981", "0380", "030", "0311", "0390", "0281", "028", "0100", "4551", "0800",
    "0803", "0808", "430", "430", "0470", "4120", "0420",
    "0855", "0430", "900", "0463", "046", "0467", "052", "0690", "0700", "072",
    "0730", "0740", "0750", "0770", "0790", "0710", "0780", "07300", "7400", "9030",
    "0510", "0551", "0580", "0611", "9002", "610", "6100", "605", "606", "750"
  ],
  it: [
    "0402", "0411", "0850", "GIFOP", "GIFTC", "GCP1000", "0210", "0990", "0980",
    "0981", "0380", "030", "0311", "0390", "0281", "028", "0100", "4551", "0800",
    "0803", "0808", "430", "430", "0470", "4120", "0420",
    "0855", "0430", "900", "0463", "046", "0467", "052", "0690", "0700", "072",
    "0730", "0740", "0750", "0770", "0790", "0710", "0780", "07300", "7400", "9030",
    "0510", "0551", "0580", "0611", "9002", "610", "6100", "605", "606", "750"
  ],
  nl: [
    "0402", "0411", "0850", "GIFOP", "GIFTC", "GCP1000", "0210", "0990", "0980",
    "0981", "0380", "030", "0311", "0390", "0281", "028", "0100", "4551", "0800",
    "0803", "0808", "430", "430", "0470", "4120", "0420",
    "0855", "0430", "900", "0463", "046", "0467", "052", "0690", "0700", "072",
    "0730", "0740", "0750", "0770", "0790", "0710", "0780", "07300", "7400", "9030",
    "0510", "0551", "0580", "0611", "9002", "610", "6100", "605", "606", "750"
  ],
  no: [
    "0402", "0411", "0850", "GIFOP", "GIFTC", "GCP1000", "0210", "0990", "0980",
    "0981", "0380", "030", "0311", "0390", "0281", "028", "0100", "4551", "0800",
    "0803", "0808", "430", "430", "0470", "4120", "0420",
    "0855", "0430", "900", "0463", "046", "0467", "052", "0690", "0700", "072",
    "0730", "0740", "0750", "0770", "0790", "0710", "0780", "07300", "7400", "9030",
    "0510", "0551", "0580", "0611", "9002", "610", "6100", "605", "606", "750"
  ],
  ru: [
    "0402", "0411", "0850", "GIFOP", "GIFTC", "GCP1000", "0210", "0990", "0980",
    "0981", "0380", "030", "0311", "0390", "0281", "028", "0100", "4551", "0800",
    "0803", "0808", "430", "430", "0470", "4120", "0420",
    "0855", "0430", "900", "0463", "046", "0467", "052", "0690", "0700", "072",
    "0730", "0740", "0750", "0770", "0790", "0710", "0780", "07300", "7400", "9030",
    "0510", "0551", "0580", "0611", "9002", "610", "6100", "605", "606", "750"
  ],
  es: [
    "0402", "0411", "0850", "GIFOP", "GIFTC", "GCP1000", "0210", "0990", "0980",
    "0981", "0380", "030", "0311", "0390", "0281", "028", "0100", "4551", "0800",
    "0803", "0808", "430", "430", "0470", "4120", "0420",
    "0855", "0430", "900", "0463", "046", "0467", "052", "0690", "0700", "072",
    "0730", "0740", "0750", "0770", "0790", "0710", "0780", "07300", "7400", "9030",
    "0510", "0551", "0580", "0611", "9002", "610", "6100", "605", "606", "750"
  ],
  uk: [
    "0402", "0411", "0850", "GIFOP", "GIFTC", "GCP1000", "0210", "0990", "0980",
    "0981", "0380", "030", "0311", "0390", "0281", "028", "0100", "4551", "0800",
    "0803", "0808", "430", "430", "0470", "4120", "0420",
    "0855", "0430", "900", "0463", "046", "0467", "052", "0690", "0700", "072",
    "0730", "0740", "0750", "0770", "0790", "0710", "0780", "07300", "7400", "9030",
    "0510", "0551", "0580", "0611", "9002", "610", "6100", "605", "606", "750"
  ],
  fi: [
    "0402", "0411", "0850", "GIFOP", "GIFTC", "GCP1000", "0210", "0990", "0980",
    "0981", "0380", "030", "0311", "0390", "0281", "028", "0100", "4551", "0800",
    "0803", "0808", "430", "430", "0470", "4120", "0420",
    "0855", "0430", "900", "0463", "046", "0467", "052", "0690", "0700", "072",
    "0730", "0740", "0750", "0770", "0790", "0710", "0780", "07300", "7400", "9030",
    "0510", "0551", "0580", "0611", "9002", "610", "6100", "605", "606", "750"
  ],
  at: [
    "0402", "0411", "0850", "GIFOP", "GIFTC", "GCP1000", "0210", "0990", "0980",
    "0981", "0380", "030", "0311", "0390", "0281", "028", "0100", "4551", "0800",
    "0803", "0808", "430", "430", "0470", "4120", "0420",
    "0855", "0430", "900", "0463", "046", "0467", "052", "0690", "0700", "072",
    "0730", "0740", "0750", "0770", "0790", "0710", "0780", "07300", "7400", "9030",
    "0510", "0551", "0580", "0611", "9002", "610", "6100", "605", "606", "750"
  ],
  cz: [
    "0402", "0411", "0850", "GIFOP", "GIFTC", "GCP1000", "0210", "0990", "0980",
    "0981", "0380", "030", "0311", "0390", "0281", "028", "0100", "4551", "0800",
    "0803", "0808", "430", "430", "0470", "4120", "0420",
    "0855", "0430", "900", "0463", "046", "0467", "052", "0690", "0700", "072",
    "0730", "0740", "0750", "0770", "0790", "0710", "0780", "07300", "7400", "9030",
    "0510", "0551", "0580", "0611", "9002", "610", "6100", "605", "606", "750"
  ],
  jp: ["0402", "0411", "0551", "GIFOP", "GIFTC", "GCP1000"],
} as const satisfies Record<string, string[]>;

export const nonMessageableProducts = {
  se: ["GCP1000"],
  us: ["GCP1000"],
  ca: ["GCP1000"],
  eu: ["GCP1000"],
  fr: ["GCP1000"],
  de: ["GCP1000"],
  it: ["GCP1000"],
  nl: ["GCP1000"],
  no: ["GCP1000"],
  ru: ["GCP1000"],
  es: ["GCP1000"],
  uk: ["GCP1000"],
  fi: ["GCP1000"],
  at: ["GCP1000"],
  cz: ["GCP1000"],
  jp: ["GCP1000"],
} as const satisfies Record<string, string[]>;
